import { axiosDoiqua } from "./configDoiqua";
import { axiosQrInstance } from "./configQrURL";
import { campaignURL, config } from "./configURL";

const data = JSON.stringify({});
const headers = {
  accept: "application/json, text/plain, */*",
  "content-type": "application/json;charset=UTF-8",
};
export const qrServices = {
  getMyPrizeList: (statusGifts) => {
    return axiosQrInstance.post(
      `/doiqua/list_win`,
      {
        params: {
          page: 1,
          limit: 0,
          exchange_status: statusGifts,
        },
      }
      // , {
      //   headers: {
      //     'Content-Type': 'application/json;charset=UTF-8',
      //   },
      // }
    );
  },
  getSOInfor: (data) => {
    return axiosQrInstance.post("/doiqua/so_info", {
      params: data,
    });
  },
  getCheckCode: (pg_so_code) => {
    return axiosQrInstance.post("/doiqua/doiqua_check_code", {
      params: {
        pg_so_code: pg_so_code,
      },
    });
  },
  postUserLogin: (data) => {
    return axiosQrInstance.post("/doiqua/doiqua_login", {
      params: data,
    });
  },
  postLogout: () => {
    return axiosQrInstance.post("/doiqua/logout", {});
  },

  postExchangeGift: (data) => {
    return axiosQrInstance.post("/doiqua/doiqua_exchange_gift_v1", {
      params: data,
    });
  },
  postUpdateConsultant: (data) => {
    return axiosQrInstance.post("/doiqua/customer_confirm", { params: data });
  },
};
